import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Navigate } from "react-router-dom";
import FameWallPte from "../components/Frontend/FameWallPte";
import Testimonial from "../components/Frontend/Testimonial";
import WhyLove from "../components/Frontend/WhyLove";
import Packages from "../components/Frontend/Packages";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import TestimonialVid from "../components/Frontend/VideoPTETestimonial";
import OurStudent from "../components/Frontend/Sliders/ourStudent";
import Slider from "react-slick";
import PhoneInputField from "components/Inputs/PhoneInputField";
import OnlineStudentSlider from "../components/Frontend/Sliders/OnlineStudentSlider";
import bannerImage from "../assets/images/public-pages/New-Public-banner.webp"
import BannerSection from "components/PublicPagesReusable/BannerSection";
import LetsCoaching from "components/PublicPagesReusable/LetsCoaching";
import WhyChoose from "components/PublicPagesReusable/WhyChoose";
import SkillAssment from "components/PublicPagesReusable/SkillAssment";
import Immigration from "../assets/images/public-pages/Online-Coaching-PTE.png";
import Speaking from "../assets/images/public-pages/core-speaking.svg";
import Writing from "../assets/images/public-pages/core-writing.svg";
import Reading from "../assets/images/public-pages/core-reading.svg"
import Listening from "../assets/images/public-pages/core-listening.svg"
import AIPowered from "../assets/images/public-pages/AI-Powered.svg";
import Training from "../assets/images/public-pages/Training-Support.svg";
import CoursePlans from "../assets/images/public-pages/CoursePlans.svg"
import Feedback from "../assets/images/public-pages/Feedback.svg"
import Strategies from "../assets/images/public-pages/Strategies.svg"
import Flexibility from "../assets/images/public-pages/Flexibility.svg";
import Friendly from "../assets/images/public-pages/Friendly.svg";
import Recognition from "../assets/images/public-pages/Recognition.svg"
import Result from "../assets/images/public-pages/Result.svg"
import Score from "../assets/images/public-pages/Score.svg"
import Frame1 from "../assets/images/public-pages/Frame1.svg"
import Frame2 from "../assets/images/public-pages/Frame2.svg"
import Frame3 from "../assets/images/public-pages/Frame3.svg"
import Frame4 from "../assets/images/public-pages/Frame4.svg"
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ComparisonSection from "components/PublicPagesReusable/ComparisionSection";
import ImmigrationSection from "components/PublicPagesReusable/ImmigrationSection";
import TestSection from "components/PublicPagesReusable/TestSection";
import AdvantageSection from "components/PublicPagesReusable/AdvantageSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import PricingSection from "components/PublicPagesReusable/PricingSection";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import SplitSection from "components/PublicPagesReusable/SplitSection";
import PromiseSection from "components/PublicPagesReusable/PromiseSection";
import OnlinePricingTable from "components/PublicPagesReusable/OnlinePricingTable";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import { PricingCard } from "./Home";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import AppDownloadPopup from "../components/Frontend/AppDownloadPopup";

const Pte = () => {
  const [isActive, setIsActive] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [course, setCourse] = useState("PTE Online");
  const [query, setQuery] = useState("");
  const [flag, setFlag] = useState(false);
  const [loginLock, setLoginLock] = useState(false);
  const [readMoreFlag, setReadMoreFlag] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [, forceUpdate] = useState();

  const images = [{
        src: Frame1,
        alt: "score-1",
      },
      {
        src: Frame2,
        alt: "score-2",
      },
      {
        src: Frame3,
        alt: "score-3",
      },
      {
        src: Frame4,
        alt: "score-4",
      },
      {
        src: Frame5,
        alt: "score-5",
      },
      {
        src: Frame6,
        alt: "score-6",
      },{
        src: Frame7,
        alt: "score-7",
      },
      {
        src: Frame8,
        alt: "score-8",
      },
      {
        src: Frame9,
        alt: "score-9",
      },
      {
        src: Frame10,
        alt: "score-10",
      },
      {
        src: Frame11,
        alt: "score-11",
      },
      {
        src: Frame12,
        alt: "score-12",
      },
      {
        src: Frame13,
        alt: "score-13",
      },
      {
        src: Frame14,
        alt: "score-14",
      },{
        src: Frame15,
        alt: "score-15",
      },
      {
        src: Frame16,
        alt: "score-16",
      },
      {
        src: Frame17,
        alt: "score-17",
      },
      {
        src: Frame18,
        alt: "score-18",
      },
      {
        src: Frame19,
        alt: "score-19",
      }
  ];

  const contentSection = () => {
    return (
   <h3 className="top-section-text FS40FW600">
   <span className="text-success FS40FW600">What Is PTE? </span><br/>
    A Test For Your Future Success
    </h3>
    )
  }

    const immigrationData = {
      title: "PTE Core Essential ",
      highlight: "For Canadian Immigration Success",
      description:
        "Meeting language requirements is the #1 factor for successful Express Entry applications",

      buttonText: "Begin Your Test Preparation",

      rightText:
        "Scoring well in PTE Core is a crucial step for Canadian immigration. The test directly impacts your:",

      benefits: [
        "Comprehensive Ranking System (CRS) points for Express Entry",
        "Provincial Nominee Program eligibility",
        "Study and work permit applications",
      ],

      cards: [
        {
          title: "Express Entry",
          subtitle: "Federal Skilled Worker",
          badge: "CLB 7",
          target: "60+",
        },
        {
          title: "Canadian Experience",
          subtitle: "Class (CEC)",
          badge: "CLB 7–9",
          target: "60–75+",
          active: true,
        },
        {
          title: "Provincial Nominee",
          subtitle: "Program (PNP)",
          badge: "Varies",
          target: "Variable",
        },
        {
          title: "Study Permits",
          subtitle: "Student Direct Stream",
          badge: "Based on Program",
          target: "50+",
        },
      ],
    };

    const skillAreaTitle = () => {
      return (
        <h3 className="top-section-text mb-4 white FS40FW600">
          The Exam Evaluates Four{" "}<br/>
          <span className="text-success FS40FW600">Essential Skill Areas</span>
        </h3>
      );
    };
    const skillAreaTitle2 = () => {
      return (
        <h3 className="top-section-text FS40FW600">
          <span className="text-success FS40FW600">
            Why Choose The PTE?{" "}
          </span>
          <br />5 Reasons It’s The Right <br/> Choice For You
        </h3>
      );
    };

    const skillAreaTitle3 = () => {
      return (
        <h3 className="top-section-text FS40FW600">
          Your PTE <span className="text-success FS40FW600">
             Online <br/>Coaching{" "}
          </span>
          Advantage
        </h3>
      );
    };

  const heroDescriptionSection = () => {
    return (<p className="sub-title text-center FS16FW500">
      Master your English skills with personalized PTE Online Training designed for non-native speakers, test takers, and students.<br/>
      Achieve high PTE scores, improve your English proficiency, and gain the confidence to reach your study, work, or residency goals<br/>
      through our comprehensive PTE Online Course.
    </p>)
  }
   const lifestyleCards = [
    {
      title: "Speaking",
      text: "Fluency, pronunciation, and coherence",
      color:"transparent",
      hoverColor: '#007AFF',
      img:Speaking,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
    {
      title: "Writing",
      text: "Essay writing, summarizing information",
      color:"transparent",
      hoverColor: "#FF3B30",
      img:Writing,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
    {
      title: "Reading",
      text: "Comprehension, vocabulary, text analysis",
      color:"transparent",
      hoverColor: "#FFCC00",
      img:Reading,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
    {
      title: "Listening",
      text: "Understanding spoken English, main ideas",
      color:"transparent",
      hoverColor: "#34C759",
      img:Listening,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
  ];

   const styleCards = [
    {
      title: "Quick Results",
      text: "Receive your scores within 48 hours—ideal for busy students and residency applicants.",
      color: "#141414",
      img: Result,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Fair Scoring System",
      text: "AI-powered scoring ensures unbiased and consistent evaluations every time.",
      color: "#141414",
      img: Score,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Flexibility",
      text: "Year-round availability and global test centers provide convenient scheduling options.",
      color: "#141414",
      img: Flexibility,
       boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "User-Friendly Format",
      text: "Fully digital, making it simpler to navigate for tech-savvy learners.",
      color: "#141414",
      img: Friendly,
       boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Comprehensive Recognition",
      text: "Accepted by global institutions and immigration authorities worldwide.",
      color: "#141414",
      img: Recognition,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    }
  ];

  const advantageCards = [
    {
      title: "AI-Powered Practice Tools",
      text: "Simulate the test environment to understand your strengths and address weaknesses",
      color: "#141414",
      img: AIPowered,
       boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Personalized PTE Online Training Support",
      text: "Receive one-on-one insights tailored for your improvement areas",
      color: "#141414",
      img: Training,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Customized PTE online Course Plans",
      text: "Develop an efficient roadmap to achieve your target scores.",
      color: "#141414",
      img: CoursePlans,
       boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Real-Time Feedback",
      text: "Fine-tune your speaking and writing skills with instant feedback through our PTE Training Online platform",
      color: "#141414",
      img: Feedback,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Proven Strategies",
      text: "Master exam techniques to maximize your performance in each skill area.",
      color: "#141414",
      img: Strategies,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    }
  ];
  const comparisionTopText = () =>{
    return (
    <p className="top-section-text FS40FW600">
      PTE Core vs. Other Tests <br/>
      <span className="text-success FS40FW600">Side-by-Side Comparison </span>
    </p>
    )
  }
  const comparisionData = [
    {
      title: "IELTS",
      subtitle: "Traditional Testing Format",
      features: [
        { label: "RESULTS TIMEFRAME", value: "13–15 days" },
        { label: "SCORING METHOD", value: "Human examiners" },
        { label: "TEST AVAILABILITY", value: "Limited seats" },
        { label: "DIGITAL FORMAT", value: "Paper & digital options" },
      ],
      cta: "Learn More",
    },
    {
      title: "PTE Core",
      subtitle: "The streamlined, AI-powered test for faster results.",
      recommended: true,
      features: [
        { label: "RESULTS TIMEFRAME", value: "48 hours" },
        { label: "SCORING METHOD", value: "AI-driven (objective)" },
        { label: "TEST AVAILABILITY", value: "Year-around, flexible" },
        { label: "DIGITAL FORMAT", value: "Fully digital" },
      ],
      cta: "Start Your Preparation Now",
    },
    {
      title: "CELPIP",
      subtitle: "Traditional Testing Format",
      features: [
        { label: "RESULTS TIMEFRAME", value: "5–8 days" },
        { label: "SCORING METHOD", value: "Mixed evaluation" },
        { label: "TEST AVAILABILITY", value: "Select centres only" },
        { label: "DIGITAL FORMAT", value: "Computer-based only" },
      ],
      cta: "Learn More",
    },
  ];
  const testData = {
    title: "Master Every",
    highlight: " PTE Skill",
    subtitle: "Our Section Specific PTE Preparation <br/> Online Strategies",
    // description: 'Our specialized PTE Core Course helps you excel in every component of the PTE Core exam:',
    tabs: [
      {
        label: "Speaking",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6673 10V10.8333C16.6673 14.5152 13.6825 17.5 10.0007 17.5C6.31875 17.5 3.33398 14.5152 3.33398 10.8333V10M10.0007 14.1667C8.1597 14.1667 6.66732 12.6743 6.66732 10.8333V5.83333C6.66732 3.99238 8.1597 2.5 10.0007 2.5C11.8416 2.5 13.334 3.99238 13.334 5.83333V10.8333C13.334 12.6743 11.8416 14.1667 10.0007 14.1667Z" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: [
            "Pronunciation, fluency, and verbal clarity.",
          ],
          rightTitle: "Our PTE Online Coaching Approach",
          rightPoints: ["AI-driven pronunciation improvement, confidence-building exercises, and fluency strategies."],
        },
      },
      {
        label: "Writing",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_2010_471)">
          <path d="M10.8346 4.99987L5.41949 6.0829C5.11699 6.1434 4.96574 6.17365 4.84257 6.24721C4.73368 6.31224 4.64107 6.40127 4.5718 6.50751C4.49344 6.62768 4.45725 6.77762 4.38487 7.07749L1.66797 18.3332M1.66797 18.3332L12.9237 15.6163C13.2236 15.5439 13.3735 15.5077 13.4937 15.4294C13.5999 15.3601 13.6889 15.2675 13.754 15.1586C13.8275 15.0354 13.8578 14.8842 13.9183 14.5817L15.0013 9.16654M1.66797 18.3332L7.98964 12.0115M17.3918 6.55707L13.4441 2.60935C13.1141 2.27934 12.9491 2.11433 12.7588 2.0525C12.5914 1.99812 12.4112 1.99812 12.2438 2.05251C12.0535 2.11433 11.8885 2.27934 11.5585 2.60935L10.9441 3.22373C10.6141 3.55375 10.4491 3.71875 10.3873 3.90903C10.3329 4.0764 10.3329 4.25669 10.3873 4.42406C10.4491 4.61433 10.6141 4.77934 10.9441 5.10935L14.8918 9.05707C15.2218 9.38708 15.3868 9.55209 15.5771 9.61391C15.7445 9.66829 15.9248 9.66829 16.0922 9.61391C16.2824 9.55209 16.4474 9.38708 16.7774 9.05706L17.3918 8.44268C17.7218 8.11267 17.8868 7.94766 17.9487 7.75739C18.0031 7.59002 18.0031 7.40973 17.9487 7.24236C17.8868 7.05209 17.7218 6.88708 17.3918 6.55707ZM9.16797 9.16654C10.0884 9.16654 10.8346 9.91273 10.8346 10.8332C10.8346 11.7537 10.0884 12.4999 9.16797 12.4999C8.24749 12.4999 7.5013 11.7537 7.5013 10.8332C7.5013 9.91273 8.24749 9.16654 9.16797 9.16654Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </g>
          </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Essay organization, grammar, summarizing passages."],
          rightTitle: "Our PTE Online Training Approach",
          rightPoints: ["Templates for essay success, grammar enhancement strategies, and summarization tips."],
        },
      },
      {
        label: "Reading",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0013 17.5L9.91792 17.3749C9.33905 16.5066 9.04962 16.0725 8.66722 15.7582C8.32868 15.4799 7.93861 15.2712 7.51931 15.1438C7.04568 15 6.52389 15 5.48032 15H4.33464C3.40121 15 2.9345 15 2.57798 14.8183C2.26438 14.6586 2.00941 14.4036 1.84962 14.09C1.66797 13.7335 1.66797 13.2668 1.66797 12.3333V5.16667C1.66797 4.23325 1.66797 3.76654 1.84962 3.41002C2.00941 3.09641 2.26438 2.84144 2.57798 2.68166C2.9345 2.5 3.40121 2.5 4.33464 2.5H4.66797C6.53481 2.5 7.46823 2.5 8.18127 2.86331C8.80848 3.18289 9.31841 3.69282 9.63799 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333M10.0013 17.5V7.83333M10.0013 17.5L10.0847 17.3749C10.6635 16.5066 10.953 16.0725 11.3354 15.7582C11.6739 15.4799 12.064 15.2712 12.4833 15.1438C12.9569 15 13.4787 15 14.5223 15H15.668C16.6014 15 17.0681 15 17.4246 14.8183C17.7382 14.6586 17.9932 14.4036 18.153 14.09C18.3346 13.7335 18.3346 13.2668 18.3346 12.3333V5.16667C18.3346 4.23325 18.3346 3.76654 18.153 3.41002C17.9932 3.09641 17.7382 2.84144 17.4246 2.68166C17.0681 2.5 16.6014 2.5 15.668 2.5H15.3346C13.4678 2.5 12.5344 2.5 11.8213 2.86331C11.1941 3.18289 10.6842 3.69282 10.3646 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        ,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Comprehension of both academic and non-academic texts, structure awareness."],
          rightTitle: "Our PTE Online Training Approach",
          rightPoints: ["Time management techniques, reordering paragraphs, and vocabulary strengthening."],
        },
      },
      {
        label: "Listening",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 15V10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10V15M4.58333 17.5C3.43274 17.5 2.5 16.5673 2.5 15.4167V13.75C2.5 12.5994 3.43274 11.6667 4.58333 11.6667C5.73393 11.6667 6.66667 12.5994 6.66667 13.75V15.4167C6.66667 16.5673 5.73393 17.5 4.58333 17.5ZM15.4167 17.5C14.2661 17.5 13.3333 16.5673 13.3333 15.4167V13.75C13.3333 12.5994 14.2661 11.6667 15.4167 11.6667C16.5673 11.6667 17.5 12.5994 17.5 13.75V15.4167C17.5 16.5673 16.5673 17.5 15.4167 17.5Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Understanding accents, note-taking, following spoken instructions."],
          rightTitle: "Our PTE Online Classes Approach",
          rightPoints: ["Simulated listening exercises, focus on accents, and key information identification."],
        },
      },
    ],
    bottomDescription:'Gain expertise in every skill area and feel fully prepared to deliver your best performance on test day.',
    cta: "Enroll In Your PTE Program",
  };

  // const advantageSectionData = {
  //   titleTop: "The Language Academy Advantage",
  //   titleMain: "Complete PTE Core Preparation System",

  //   highlightBox:
  //     "91% of our students achieve their target scores within two attempts",

  //   description:
  //     "At Language Academy, we've developed a comprehensive PTE Core Course combining technology, expert instruction, and proven methodologies.",

  //   buttonText: "Book Your Preparation Session",

  //   timeline: [
  //     {
  //       number: 1,
  //       title: "PTE Core Practice Material",
  //       desc: "Experience the actual PTE Core test environment with our simulation technology that mirrors the real exam algorithms.",
  //     },
  //     {
  //       number: 2,
  //       title: "Detailed Performance Analytics",
  //       desc: "Receive comprehensive score breakdowns showing exactly where you're losing points and how to improve.",
  //     },
  //     {
  //       number: 3,
  //       title: "Expert PTE Core Preparation Guidance",
  //       desc: "Learn from tutors who specialize in PTE Core Online Training",
  //     },
  //     {
  //       number: 4,
  //       title: "PTE Core Practice Materials & Strategies",
  //       desc: "Apply our time-tested resources specifically designed to maximize scores",
  //     },
  //   ],
  // };  

  const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  },

    items: [
      {
        id: 1,
        name: "Manisha Rathore",
        location: "Jodhpur City, Rajasthan, India",
        description:
          "I achieved 90 overall by the help of tricks and tips suggested by tutors on language academy online portal and sessions. I highly recommend the course. Special thanks to Varun sir and Shiba mam.",
        image: "/images/web-new-images/new-content-slider/Manisha-rathore.svg",
      },
      {
        id: 2,
        name: "Shoaib Awan",
        location: "Abbottabad",
        description:
          "Sir Varun’s tips and tricks really helped me gain a score that was way better than my desired score in the very first attempt. Thank you so much Sir Varun and team language academy. You guys are doing a great job.",
        image: "/images/web-new-images/new-content-slider/shoaib-awan.svg",
      },
      {
        id: 3,
        name: "Varinder Sandhu",
        location: "Kot-Ise-Khan, Punjab, India",
        description:
          "Hii I am a online student of language academy I took online PTE coaching from language academy and today I have achieve my desired score with the help of language academy secret strategies and tips special thanks to manan wadhwa mam she helped me alot  in my PTE classes",
        image: "/images/web-new-images/new-content-slider/varinder-sandhu.svg",
      },
      {
        id: 4,
        name: "Khalid Hasan",
        location: "Adelaide, South Australia",
        description:
          "The mock tests & the feedback were really helpful to overcome my mistakes. The writing template helped me to get full 90 bands & the other resources helped me to gain an  overall score of 83 out of 90. I highly recommend it.",
        image: "/images/web-new-images/new-content-slider/khalid-hasan.svg",
      },
      {
        id: 5,
        name: "Ahmad Rasheed",
        location: "Hyderabad, India",
        description:
          "It was a great experience learning at a language academy, especially Mr.Varun whose videos,  tips and tricks helped me a lot to crack money in my very first attempt.",
        image: "/images/web-new-images/new-content-slider/ahmad-rasheed.svg",
      },
      {
        id: 6,
        name: "Akhil Raj",
        location: "Dubai, UAE",
        description:
          "Well experienced and friendly faculties. They are providing educational support even during off hours. I highly recommend it.",
        image: "/images/web-new-images/new-content-slider/akhil-raj.svg",
      },
      {
        id: 7,
        name: "Pranav Patel",
        location: "Gandhinagar, Gujarat",
        description:
          "I was preparing for 79+ in PTE on my own and I couldn’t get it despite trying very hard. After following Varun’s tips, tricks and strategies, and practicing them on LA’s portal I successfully got 79+ in all the four modules in 1st try. I highly recommend Varun and LA if you are preparing for PTE. Thanks heaps Varun!",
        image: "/images/web-new-images/new-content-slider/pranav-patel.svg",
      },
      {
        id: 8,
        name: "Dushyant Singh Raghav",
        location: "Ghaziabad, India",
        description:
          "I highly recommend the mock tests from Language Academy as they played a key role in helping me achieve an overall score of 90 in the PTE. The section-specific templates were especially useful, enabling me to score 90 in three bands and 87 in one.",
        image: "/images/web-new-images/new-content-slider/dushyant-singh-raghav.svg",
      },
      {
        id: 9,
        name: "Inderpal Kaur",
        location: "Australia",
        description:
          "It's a great platform for PTE and NAATI  training. I have achieved my desired score of  79 each in PTE after 2 weeks of classes. The tutor taught great techniques and one on one sessions were very helpful. I’m preparing for my NAATI training in LA as well. Highly recommended.",
        image: "/images/web-new-images/new-content-slider/inderpal-kaul.svg",
      },
      {
        id: 10,
        name: "Shayna Sunsara",
        location: "Melbourne, Victoria, Australia",
        description:
          "I highly recommend practising at Language Academy as it is very similar to a real test and gives you a very accurate idea, what you will face in the real exam. I have achieved my desired score of 90 because of practicing at a language academy. Thank you",
        image: "/images/web-new-images/new-content-slider/shayna-sunsara.svg",
      },
      {
        id: 11,
        name: "Gurpreet Sidhu",
        location: "Adelaide, South Australia",
        description:
          "Hi LA team, Thank you so much for being great in the market to guide us in the right direction. Special thanks to Varun Sir for all the motivation and regular updates. 100% recommended 👍",
        image: "/images/web-new-images/new-content-slider/gurpreet-sidhu.svg",
      },
       {
        id: 12,
        name: "Farid Sn",
        location: "Kuala Lumpur, Malaysis",
        description:
          "The strategies and templates worked very well for me and helped me achieve a superior score on the first attempt. The LA portal has one of the best AI engines that provides accurate scoring.",
        image: "/images/web-new-images/new-content-slider/inderpal-kaul.svg",
      },
    ],
  };

  const pricingData = {
    title: "<span class='main-title FS40FW600'>Start Your</span> <span class='text-success FS40FW600'>Online Coaching</span><span> Plan</span>",
    // highlight: "Online Coaching",
    // secondTitle:'Plan',
    subtitle: "Choose your preparation package",
    plans: [
      {
        title: "Online Platform",
        price: 29,
        description: "All core features, enhanced with",
        features: [
          "AI-Powered Portal Access",
          "Complete Question Bank",
          "Scored Mock Tests",
          "Updated Templates",
          "Self-Paced Video Lessons",
        ],
        buttonText: "Start Your Plan",
        isPopular: false,
      },
      {
        title: "Online Coaching",
        price: 249,
        description: "Everything in the Online Platform package, PLUS:",
        features: [
          "Live Virtual Classes",
          "Personalized Feedback",
          "Direct Trainer Access",
          "Priority Support",
        ],
        buttonText: "Start Your Plan",
        isPopular: true,
        badgeText: "BEST SELLER",
      },
    ],
  };

  const faqQuestions = [
    {
      question: "How long does it take to prepare for the PTE test with your PTE Online Coaching?",
      answer: "Most students need 4-6 weeks of consistent PTE Training Online to achieve their target scores. However, preparation time varies based on your current English level and target score requirements."
    },
    {
      question: "Do you offer a money-back guarantee?",
      answer: "We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us."
    },
    {
      question: "How quickly can I see improvements in my PTE scores?",
      answer: "Many students see significant improvements within 2-3 weeks of starting our program. However, individual progress depends on your starting level and dedication to practice."
    },
    {
      question: "Is the AI practice platform similar to the real PTE test?",
      answer: "Yes, our AI-powered PTE Online Classes practice tools are designed to closely simulate the actual PTE test environment, helping you become familiar with the format and timing."
    },
    {
      question: "Can I reschedule my coaching sessions if needed?",
      answer: "Yes, we offer flexible scheduling for all our coaching sessions. You can reschedule with reasonable notice to accommodate your availability."
    },
    // {
    //   question: "What support do I get after completing the PTE Online Coaching program?",
    //   answer: "Premium and VIP students receive ongoing PTE Training Online support until they achieve their target scores. We also provide guidance on test booking and PTE Preparation Online strategies for your official PTE exam."
    // }
  ];

  const validatorRef = useRef(
    new SimpleReactValidator()
  );
  const validator = validatorRef.current;

  const handleClick = () => {
    setIsActive((prevState) => !prevState);
  };

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const submitForm = (e) => {
    e.preventDefault();
    hitApi();
  };

  const changeReadMore = () => {
    setReadMoreFlag(!readMoreFlag);
  };

  const hitApi = async () => {
    if (loginLock) {
      return;
    }
    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }
    setLoginLock(true);

    var bodyFormData = new FormData();
    bodyFormData.set("email", email);
    bodyFormData.set("name", name);
    bodyFormData.set("phone", phone);
    bodyFormData.set(
      "message",
      "<b>course:</b> " +
      course +
      "<br/><b>Query:</b> " +
      query
    );
    bodyFormData.set(
      "data",
      "email: " +
      email +
      ",name: " +
      name +
      ",phone: " +
      phone +
      ",course: " +
      course +
      ",query: " +
      query
    );
    bodyFormData.set("page", "PTE Online Sydney");
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) { }
    console.log(res);
    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message })
      );
      setName("");
      setEmail("");
      setPhone("");
      setCourse("PTE On-Campus");
      setQuery("");
      setLoginLock(false);
      setFlag(true);
    } else {
      setLoginLock(false);
    }
  };

  const changeInput = (e) => {
    let { name: fieldName, value } = e.target;
    if (fieldName === "name") setName(value);
    else if (fieldName === "email") setEmail(value);
    else if (fieldName === "phone") setPhone(value);
    else if (fieldName === "course") setCourse(value);
    else if (fieldName === "query") setQuery(value);
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }
  const bannerTitle = () => {
    return (
      <h1 className="FS56FW500 top-section-text">
        <span className="text-success">Master PTE</span> From Anywhere:
        <br />
        Expert PTE Online Coaching That Delivers Real Results.
      </h1>
    );
  }

  
  const subTitleSection = () => {
    return (<p className="sub-title white">
      Get the same quality instruction and personalized attention <br className="d-none d-md-block" /> as in-person classes, with the flexibility you need.
    </p>)
  }

  const letsCoachingText = () => {
    
    return ( <h2 className="primary-heading fw-700">
                  PREPARE FOR <span className="wpl-badge gold-badge text-white">
                    PTE SUCCESS
                  </span>
                  <br />
                  
                    with expert GUIDANCE
                 
                  <br />
                  IN PARRAMATTA
                </h2>
 )
  }
  const skillData = [
    {
      id: 1,
      title: "Speaking",
      description: "Fluency, pronunciation and coherence",
      image: "/images/web-new-images/icons/w-speak-icon.svg",
      color: "#c42fed"
    },
    {
      id: 2,
      title: "Writing",
      description: "Essay writing, sumarizing information",
      image: "/images/web-new-images/icons/w-write-icon.svg",
      color: "#6366F1"
    },
    {
      id: 3,
      title: "Reading",
      description: "Comprehesion, vocabulary, text analysis",
      image: "/images/web-new-images/icons/w-reading-icon.svg",
      color: "#8B5CF6"
    },
    {
      id: 4,
      title: "Listening",
      description: "Understanding spoken English, main ideas",
      image: "/images/web-new-images/icons/w-listen-icon.svg",
      color: "#7E22CE"
    }
  ];

  const spliteSectionData = {
    title: "Prepare For",
    highlight: " PTE With Expert Guidance",
    subTitle: ' Your Key To Success',
    quote: "Struggling with English proficiency or unfamiliar test formats? You're not alone! We understand the challenges non-native English speakers face, especially when aiming for residency, work, or study opportunities abroad.",
    descriptions: ["Our PTE Coaching Classes solutions are tailored to:",],
    features: [
      "Boost English proficiency",
      "Increase test-taking confidence",
      "Provide personalized study strategies",
    ],
    buttonText: "Book Your Free Trial Class",
    onButtonClick: () => {
      const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
      modal.show();
    },
    image: "/images/web-new-images/emojis/Updated/PTE-experts.svg",
    imagePosition: "left",
    bgColor: "#080F1E",
    textColor: "#ffff",
  };

  const whyChooseSectionHeader = () => {
    return (
      <h2 className="primary-heading text-center fw-700">
        <span className="wpl-badge gold-badge text-white">
          WHY CHOOSE PTE?
        </span>{" "}
        <br className="d-block" />5 REASONS IT'S THE RIGHT{" "}
        <br className="d-none d-md-block" /> CHOICE FOR YOU
      </h2>
    )
  }
  const blueBoxText = () => {
    return (<div className="light-blue-box">
      Master your English skills with personalized PTE Online Training designed for non-native speakers, test takers, and students. Achieve high PTE scores, improve your English proficiency, and gain the confidence to reach your study, work, or residency goals through our comprehensive PTE Online Course.
    </div>)
  }
  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text"><span className="text-success fw-600">Master Your PTE </span> From Anywhere: 
          <br />
          Best PTE Online Coaching That Delivers Real Results
      </h1>
    );
  };
  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: heroWorkTitle,
    subtitle: "Get the same quality instruction and personalized attention as in-person classes, with the flexibility you need.",
    btn_prepration: { text: "Start Your PTE Coaching", onClick: '/auth/register' },
    btn_outline: { text: "Free Mock Test", variant: "outline", link: '/auth/register' },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/Pritam.svg",
      "/images/web-new-images/new-content-slider/Karthik-B.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students'",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" }
      ]
    },
    bottomStats: [
      { value: "8",highlight:'+', label: "Years of PTE Expertise" },
      { value: "30", highlight:'+', label: "Countries Served" },
      { value: "/5", highlight:'4.8', label: "Rated PTE Practice App" },
      { value: "-Powered", highlight:'AI', label: "Scoring Engine" }
    ]
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>PTE Online Coaching Classes Australia | LA Language Academy</title>
        <meta name="description" content="Enrol in LA Language Academy's PTE online coaching classes for expert guidance. Achieve your best PTE score with flexible, personalized learning." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/pte-online-coaching`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="PTE Online Coaching Classes Australia | LA Language Academy" />
        <meta name="twitter:description" content="Enrol in LA Language Academy's PTE online coaching classes for expert guidance. Achieve your best PTE score with flexible, personalized learning." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/pte-online-coaching`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PTE Online Coaching Classes Australia | LA Language Academy" />
        <meta property="og:description" content="Enrol in LA Language Academy's PTE online coaching classes for expert guidance. Achieve your best PTE score with flexible, personalized learning." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">

        <Header />

        {/* <BannerHeader title={bannerTitle} blueBoxText={blueBoxText} subTitle={subTitleSection} backgroundColor='#182A4F' textColor="white" middleSection={() => {
          return ( 
            
            <div className="banner-img-wrapper" style={{paddingBottom: '232px'}}>
              <img 
            className="banner-img"
            src={bannerImage}
            alt="LA"  
          />
          </div>
            
)
        }} /> */}
         <HeroSectionUpdated data={heroData} />
        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>
        <div className="d-flex align-items-center gap-3 flex-column pb-4 off-white">
            {heroDescriptionSection()}
            <ButtonComp 
              link={() => {
              const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
              modal.show();
              }}
              btnText={"Book Your Free Trial Class"}
            />
        </div>
          <div className="custom-container py-5">
            <ContentImageSection
            contentSection={contentSection}
            quoteText='The PTE (Pearson Test of English) is a computer-based test designed to assess English proficiency for academic, work, or immigration purposes. Our PTE Training Online program helps you master this fast, efficient, and globally recognized test.'
            btnLink="/auth/register"
            btnText="Start Your PTE Journey Now"
            btnClassName="mt-2"
            image={Immigration}
          imageClassName="immigration-test-img"
    />
          </div>
        <SkillAreas
        skillAreaTitle={skillAreaTitle} 
        lifestyleCards={lifestyleCards} 
        btnText={"Start Your PTE Journey Now"}
        skillSubtitle={"By pairing your motivation with structured preparation, you'll not only perform well but also gain the confidence needed to tackle the test format head-on. So why wait?"}
        />
        <SkillAreas 
        className={"skill-section"}
        background={"white"}
        color={"black"}
        skillAreaTitle={skillAreaTitle2} 
        lifestyleCards={styleCards} 
        btnText={"Register For Your PTE Prep Course"}
        skillSubtitle={"Leave behind outdated and less efficient test formats—PTE offers a modern, streamlined option that aligns with your goals. Our PTE Preparation Online program ensures you're fully prepared."}
        />
        {/* <ComparisonSection
        data={comparisionData} 
        comparisionTopText={comparisionTopText}
        comparisionDescriptionText={`Say goodbye to the delays and complications of traditional language tests. Choose PTE Core for a <br/> streamlined and efficient testing experience.`} />
         */}
         <SplitSection {...spliteSectionData}  />
        {/* <ImmigrationSection data={immigrationData} /> */}
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle3}
          lifestyleCards={advantageCards}
          btnText={"Achieve Your PTE Goals With Us"}
          skillSubtitle={"Our platform combines cutting-edge learning tools, experienced tutors, and proven strategies to deliver consistent results. At the heart of our PTE Online Classes practice are:"}
        />

        <TestSection data={testData} bgColor="#080F1E" />

        {/* <AdvantageSection data={advantageSectionData} /> */}
        <PromiseSection
          isSmallWidth={true}
          subtitle="Our Promise"
          title="PTE Online Coaching You Can Count On"
          description="At <span class='fw-bold'>Language Academy</span>, we believe in empowering students to overcome their language  struggles and achieve life-changing results. We address your primary complaints, lack of  confidence, test anxiety, and unfamiliarity with the format, through expert coaching and  detailed preparation plans."
        />

        <TestimonialSection
          title={`<span class="hero-title FS40FW600 text-center mb-0">Hear From Our PTE <br/> <span class="green-text">Training Online Students'</span></span>`}
          subtitle={'Your Success Is Our Goal, Achieve yours today.'}
          showBtn={false}
          sliderList={sliderList}
        />

        <AiPower btnText="Start Free PTE Practice" />
        
        {/* <PricingSection data={pricingSectionData} /> */}
        {/* <OnlinePricingTable {...pricingData}/> */}

        <div className="container py-5">
                          <div className="text-center">
                            <h3 className='main-title FS40FW600 mb-0'>Start Your  <span className='text-success FS40FW600'>Online <br/> Coaching</span> Plan</h3>
                            <p className="quote-para FS18FW400 fw-500 py-4">Choose your preparation package</p>
                          </div>
                          <div className="row justify-content-center">
                
                            <PricingCard
                              title="PACKAGE 1"
                              subtitle="Online Platform"
                              price="29"
                              features={[
                                "AI-Powered Portal Access",
                                "Complete Question Bank",
                                "Scored Mock Tests",
                                "Updated Templates",
                                "Self-Paced Video Lessons",
                              ]}
                              description={'All core features, enhanced with'}
                            />
                
                            <PricingCard
                              title="PACKAGE 2"
                              subtitle="Online Coaching"
                              price="249"
                              isPopular={true}
                              dark={true}
                              features={[
                                "Live Virtual Classes",
                                "Personalized Feedback",
                                "Direct Trainer Access",
                                "Updated Prediction Files",
                                "Priority Support",
                              ]}
                              description={'Everything in Online Platform, plus'}
                            />
                
                             <PricingCard
                                                          title="MOBILE"
                                                          subtitle="PTE Practice App"
                                                          price="Free"
                                                          isFree={true}
                                                          currency="to download"
                                                          features={[
                                                            "Available on iOS & Android",
                                                            "Practice Questions",
                                                            "AI-Scored Speaking",
                                                            "Performance Tracking",
                                                            "4.8/5 Star Rating",
                                                          ]}
                                                          description={'Practice on the go'}
                                                            onDownloadClick={() => setShowDownloadModal(true)}
                                                        />
                
                          </div>
                        </div>

        {/* <PteAppBanner /> */}
        <AppBannerCustom
          appName="PTE"
          description="PTE PRACTICE"
          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
        />

        <FaqSection questions={faqQuestions}/>
        <Footer />
      </div>

      {/* OLD CODE DONT TOUCh */}
      <div className="d-none">
        <BannerSection title={bannerTitle} blueBoxText={blueBoxText} subTitle={subTitleSection} />



        <div className="noc-ccl-exam naati-ccl-exam poc-future-success">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge text-white">WHAT IS PTE?</span>
                  <br className="d-block" />
                  A TEST FOR YOUR <br /> FUTURE SUCCESS
                </h2>
              </div>
              <div className="col-md-6">
                <div className="ccl-exam-img">
                  <img
                    src="/images/web-new-images/poc-img.png"
                    alt="Register Now"
                  />
                </div>
              </div>
              <div className="col-md-6 what-ielts-content">
                <p>
                  The PTE (Pearson Test of English) is a computer-based test designed to assess English proficiency for academic, work, or immigration purposes. Our PTE Training Online program helps you master this fast, efficient, and globally recognized test.
                </p>
              </div>
            </div>
            <SkillAssment skillData={skillData}  />
          </div>
        </div>

        <WhyChoose whyChooseSectionHeader={whyChooseSectionHeader} />

        <LetsCoaching title={letsCoachingText} />

        <div className="ielts-achievment">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <h2 className="primary-heading fw-700">
                  <span className="wpl-badge text-white">
                    OUR PROMISE
                  </span>
                  <br />
                  PTE ONLINE COACHING <br className="d-none d-md-block" /> YOU CAN COUNT ON
                </h2>
              </div>
              <div className="col-lg-6">
                <div className="achievment-card">
                  <div className="icon-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 21.6885L11.8999 21.5384C11.2053 20.4964 10.858 19.9754 10.3991 19.5983C9.99286 19.2644 9.52476 19.0139 9.02161 18.8611C8.45325 18.6885 7.82711 18.6885 6.57482 18.6885H5.2C4.07989 18.6885 3.51984 18.6885 3.09202 18.4705C2.71569 18.2787 2.40973 17.9728 2.21799 17.5965C2 17.1686 2 16.6086 2 15.4885V6.88848C2 5.76837 2 5.20832 2.21799 4.7805C2.40973 4.40417 2.71569 4.09821 3.09202 3.90646C3.51984 3.68848 4.07989 3.68848 5.2 3.68848H5.6C7.84021 3.68848 8.96031 3.68848 9.81596 4.12445C10.5686 4.50794 11.1805 5.11987 11.564 5.87251C12 6.72816 12 7.84827 12 10.0885M12 21.6885V10.0885M12 21.6885L12.1001 21.5384C12.7947 20.4964 13.142 19.9754 13.6009 19.5983C14.0071 19.2644 14.4752 19.0139 14.9784 18.8611C15.5467 18.6885 16.1729 18.6885 17.4252 18.6885H18.8C19.9201 18.6885 20.4802 18.6885 20.908 18.4705C21.2843 18.2787 21.5903 17.9728 21.782 17.5965C22 17.1686 22 16.6086 22 15.4885V6.88848C22 5.76837 22 5.20832 21.782 4.7805C21.5903 4.40417 21.2843 4.09821 20.908 3.90646C20.4802 3.68848 19.9201 3.68848 18.8 3.68848H18.4C16.1598 3.68848 15.0397 3.68848 14.184 4.12445C13.4314 4.50794 12.8195 5.11987 12.436 5.87251C12 6.72816 12 7.84827 12 10.0885"
                        stroke="#94C23C"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="achievment-content">
                    <p className="mt-2">
                      At <strong className="fw-700">Language Academy,</strong> we believe in empowering students to overcome their language struggles and achieve life-changing results. We address your primary complaints, lack of confidence, test anxiety, and unfamiliarity with the format, through expert coaching and detailed preparation plans.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sss-section">
          <OnlineStudentSlider title={`<span className="fw-700">Hear From Our`} />
          <div className="container">
            <div className="text-center bottom-btn-wrapper">
              <p className="sub-heading">
                Your Success Is Our Goal, Achieve yours today.
              </p>
              <Link to="/auth/register" className="primary-btn">
                REGISTER FOR YOUR COURSE
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>


        <div className="pte-campus poc-campus">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center poc-campus-header">
                <h2 className="primary-heading">
                  START YOUR
                  <br />
                  <span className="wpl-badge gold-badge text-white mb-2">
                    ONLINE COACHING
                  </span>
                  <br />
                  PLAN
                </h2>
                <p className="text-uppercase">
                  Choose Your Preparation Package
                </p>
              </div>
              <div className="col-lg-6">
                <div className="pte-campus-list card1">
                  <div className="green-package-badge">PACKAGE OPTION 1</div>
                  <h2 className="list-title">ONLINE PLATFORM</h2>
                  <ul>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        AI-POWERED PORTAL ACCESS
                      </h3>
                      <p>
                        Full access to our proprietary practice platform with algorithm-based scoring
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        COMPLETE QUESTION BANK
                      </h3>
                      <p>
                        8,000+ practice questions covering all exam modules and question types
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        SCORED MOCK TESTS
                      </h3>
                      <p>
                        Take full-length simulations with precise feedback that mirrors the real exam
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        UPDATED TEMPLATES
                      </h3>
                      <p>
                        Access the latest templates designed to trigger maximum points in the scoring system
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        SELF-PACED VIDEO LESSONS
                      </h3>
                      <p>
                        Learn the core strategies at your own pace with expert-guided tutorials
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="pte-campus-list card2">
                  <div className="purple-package-badge">PACKAGE OPTION 2</div>
                  <h2 className="list-title">ONLINE COACHING</h2>
                  <h2 className="list-sub-title">Everything in the Online Platform package, PLUS</h2>
                  <ul>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        LIVE VIRTUAL CLASSES
                      </h3>
                      <p>
                        Join expert-led sessions focusing on each component of the exam
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        PERSONALIZED FEEDBACK
                      </h3>
                      <p>
                        Receive detailed analysis of your performance with specific improvement strategies
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        DIRECT TRAINER ACCESS
                      </h3>
                      <p>
                        Get your questions answered directly by our experienced instructors
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        PREDICTION FILES
                      </h3>
                      <p>
                        Access constantly updated prediction materials based on recent exam patterns
                      </p>
                    </li>
                    <li>
                      <h3>
                        <svg
                          width="40"
                          height="41"
                          viewBox="0 0 40 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            y="0.301758"
                            width="40"
                            height="40"
                            rx="20"
                            fill="#48A75C"
                            fillOpacity="0.12"
                          />
                          <path
                            d="M28 14.3018L17 25.3018L12 20.3018"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        PRIORITY SUPPORT
                      </h3>
                      <p>
                        Fast-track assistance whenever you face challenges in your preparation
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="text-center pte-campus-btns">
                  <Link to="/auth/register" className="primary-btn ouiline-btn mb-2">
                    Contact Us
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                  <Link to="/auth/register" className="primary-btn">
                    Register On Online Platform
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="downlaodnow-row d-none">
              <div className="downlaodnow-content">
                <h2>PTE APP</h2>
                <p>
                  Download our PTE App
                  <br />
                  from App Store and Play Store
                </p>
              </div>
              <div className="downlaodnow-img">
                <img
                  src="/images/web-new-images/welcome-img.png"
                  alt="Register Now"
                />
              </div>
              <div className="downlaodnow-third-col">
                <h3 className="downlaodnow-title">Download Now!</h3>
                <div className="downlaodnow-btns">
                  <a target="_blank" href="https://play.google.com/store/apps/details?id=com.languageacademy" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a target="_blank" href="https://apps.apple.com/au/app/la-pte/id6443614190" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>
              </div>
            </div>
            <AppBannerCustom
              appName="PTE"
              description="PTE PRACTICE"
              mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
              playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
              appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
            />
          </div>
        </div>

        <div className="faq-section mt-faq">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>

              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How long does it take to prepare for the PTE test with your PTE Online Coaching?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Most students need 4-6 weeks of consistent PTE Training Online to achieve their target scores. However, preparation time varies based on your current English level and target score requirements.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Do you offer a money-back guarantee?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      How quickly can I see improvements in my PTE scores?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Many students see significant improvements within 2-3 weeks of starting our program. However, individual progress depends on your starting level and dedication to practice.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Is the AI practice platform similar to the real PTE test?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, our AI-powered PTE Online Classes practice tools are designed to closely simulate the actual PTE test environment, helping you become familiar with the format and timing.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Can I reschedule my coaching sessions if needed?
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, we offer flexible scheduling for all our coaching sessions. You can reschedule with reasonable notice to accommodate your availability.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSix">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      What support do I get after completing the PTE Online Coaching program?
                    </button>
                  </h2>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Premium and VIP students receive ongoing PTE Training Online support until they achieve their target scores. We also provide guidance on test booking and PTE Preparation Online strategies for your official PTE exam.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />

        <div
          className="modal fade"
          id="staticBackdrop1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog main-popup">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/icons/close-icon2.svg"
                      alt="LA"
                    />
                  </span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="form-content-outer m-0">
                  <div className="form-content">
                    <div className="main-popup-img form-img">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/hero_img-02.png"
                        alt="LA"
                      />
                    </div>
                    <div className="main-popup-content form-content-right">
                      <h4 className="popup-title">Take a FREE Demo Class</h4>
                      <p className="popup-sub-title">
                        Submit Your Details Below
                      </p>
                      <div className="pte-popup-form-start">
                        <form onSubmit={submitForm}>
                          <div className="fieldOuter">
                            <label htmlFor="name">Name*</label>
                            <div className="form-input-outer">
                              <input
                                id="name"
                                className="form-input"
                                type="text"
                                name="name"
                                placeholder="Enter name"
                                value={name}
                                onChange={(e) => {
                                  changeInput(e);
                                }}
                              />
                            </div>
                            {validator.message(
                              "Name",
                              name,
                              "required"
                            )}
                          </div>
                          {/* <div className="fieldOuter">
                        <div className="form-input-outer">
                          <input
                            className="form-input"
                            type="text"
                            placeholder="Phone*"
                            name="phone"
                            value={phone}
                            onChange={(e) => { changeInput(e)} }
                          />
                        </div>
                          {validator.message('Phone', phone, 'required')}
                        </div> */}
                          <div className="fieldOuter">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <PhoneInputField
                              id="PhoneNumber"
                              value={phone}
                              changeEvent={handlePhoneChange}
                              addClass="popup-class"
                            />
                            {validator.message(
                              "phone",
                              phone,
                              "required|phone"
                            )}
                            <span className="err phone-error"></span>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="email">Email*</label>
                            <div className="form-input-outer">
                              <input
                                id="email"
                                className="form-input"
                                type="text"
                                name="email"
                                placeholder="Enter Email"
                                value={email}
                                onChange={(e) => {
                                  changeInput(e);
                                }}
                              />
                            </div>
                            {validator.message(
                              "Email",
                              email,
                              "required|email"
                            )}
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="center">Center</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                id="center"
                                className="form-input"
                                name="course"
                                value={course}
                                onChange={(e) => {
                                  changeInput(e);
                                }}
                              >
                                <option value="PTE Online">PTE Online</option>
                                <option value="PTE On-Campus3">
                                  PTE On-Campus
                                </option>
                                <option value="NAATI CCL Online">
                                  NAATI CCL Online
                                </option>
                                <option value="NAATI CCL On-Campus">
                                  NAATI CCL On-Campus
                                </option>
                                <option value="IELTS Online">
                                  IELTS Online
                                </option>
                                <option value="IELTS On-Campus">
                                  IELTS On-Campus
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="comments">Comments / Query</label>
                            <div className="form-input-outer">
                              <input
                                id="comments"
                                className="form-input"
                                type="text"
                                placeholder="Enter your comments/Query"
                                name="query"
                                value={query}
                                onChange={(e) => {
                                  changeInput(e);
                                }}
                              />
                            </div>
                            {validator.message(
                              "Query",
                              query,
                              "required"
                            )}
                          </div>
                          <div className="fieldOuter mb-0">
                            {!loginLock && (
                              <button
                                className="primary-btn"
                                onClick={(e) => {
                                  hitApi();
                                }}
                              >
                                SUBMIT{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button>
                            )}
                            {loginLock && (
                              <button className="themeBtn">Wait...</button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AppDownloadPopup 
          showDownloadModal={showDownloadModal}
          setShowDownloadModal={setShowDownloadModal}
        />
      </div>
    </React.Fragment>
  );
};

export default Pte;